import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Input,
  DatePicker,
  Select,
  message,
} from "antd";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { MdCheck } from "react-icons/md";
import fetchDataTrace from "../../../../services/fetchDataTrace";
import postDataTrace from "../../../../services/postDataTrace";
import logo from "../../../../assets/images/logo-red.png";
import getBase64 from "../../../../utils/getBase64";
import { AuthContext } from "../../../../contexts/AuthContext";
const { Option } = Select;
const { TextArea } = Input;

export default function CreateCustomer({ isVisible, hideModal, refetch }: any) {
  const { user } = useContext(AuthContext);
  const [slotModal, setSlotModal] = useState(false);
  const [selectedTime, setSelectedTime] = useState<any>(null);
  const [availability, setAvailability] = useState<any>(null);
  const [date, setDate] = useState(null);
  const [models, setModels] = useState<any>([]);
  const [isOtherModel, setIsOtherModel] = useState<boolean>(false);
  const [isChecking, setChecking] = useState<boolean>(false);
  const [isEm, setEm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState<number>(10);
  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile]: any = useState();

  const specialServiceSites = [
    "Toyota HQ ( Dar es salaam )",
    "Arusha",
    "Mbeya",
    "Tanga",
  ];

  const safariServiceSites = ["Toyota HQ ( Dar es salaam )", "Arusha"];

  const [form] = Form.useForm();

  const disabledDate = (current: any) => {
    const today = new Date();
    const twoDaysFromNow = new Date();
    twoDaysFromNow.setDate(today.getDate() + 2);
    return (
      current < Date.now() + 2 ||
      new Date(current).getDay() === 0 ||
      new Date(current).getDay() === 6
    );
  };
  const startsWith = (str: any, word: any) => {
    return str.lastIndexOf(word, 0) === 0;
  };

  const onSubmit = async () => {
    setIsLoading(true);
    const {
      vehicle,
      model,
      othermodel,
      mileage,
      year,
      vehicle_vin,
      vehicle_engine,
      description,
      customer_name,
      customer_email,
      customer_mobile,
      customer_address,
      customer_comments,
      promo_code,
    } = await form.validateFields();
    let formatedMob = null;
    if (customer_mobile) {
      const trimmed = customer_mobile.replace(/\s/g, "");
      if (trimmed.toString().length === 10) {
        let zero = startsWith(`${trimmed}`, "0");
        if (zero) {
          let num = trimmed.substring(1);
          formatedMob = `+255${num}`;
        }
      } else {
        if (trimmed.toString().length < 9 || trimmed.toString().length > 9) {
          message.error("Please provide a valid number");
          return;
        }
        formatedMob = `+255${trimmed}`;
      }
    }

    let base64 = null;
    if (selectedFile) {
      base64 = await getBase64(selectedFile);
    }

    let formatedReg = vehicle.replace(/\s/g, "").toUpperCase();
    const data = {
      date: moment(selectedTime?.starttime).format("YYYY-MM-DD"),
      time: selectedTime?.starttime,
      description: description,
      slottime: selectedTime?._id,
      site: user?.site,
      title: `${formatedReg}`,
      vehicle: formatedReg,
      mileage: mileage,
      model_year: year,
      model: isOtherModel ? othermodel : model,
      status: "Unconfirmed",
      contact: "",
      vehicle_vin: vehicle_vin,
      vehicle_engine: vehicle_engine,
      is_confirmed: false,
      booking_source: "internal:web",
      customer_id: 126,
      customer_name: customer_name,
      customer_code: 0,
      attachment: base64,
      customer_email: customer_email,
      customer_mobile: formatedMob,
      customer_address: customer_address,
      customer_comments: customer_comments,
      promo_code: promo_code,
    };

    const uri = `bookings`;

    const response = await postDataTrace(data, uri);

    if (response.success === false) {
      message.error(response.message);
      return;
    }

    message.success("Booking added successfully");
    await refetch();
    hideModal();
    setIsLoading(false);
  };

  const clearForm = async () => {
    form.resetFields();
    setDate(null);
    setIsLoading(false);
  };

  const handleHideModal = () => {
    setSlotModal(false);
    setIsLoading(false);
  };

  const year = new Date().getFullYear() + 1;

  const years: any = [];

  for (let i = 1998; i < year; i++) {
    years.unshift({ year: i });
  }

  const checkEM120 = (bookings: any) => {
    let em = 0;
    let ot = 0;
    let rm = 0;
    bookings?.forEach((item: any) => {
      if (item?.description === "EM120") {
        em = em + 1;
      } else {
        ot = ot + 1;
      }
    });
    let x = 10 - ot;
    if (x >= 4) {
      rm = 4 - em;
    } else {
      rm = x - em;
    }
    return rm;
  };

  const onChangeDate = async (event: any, selectedDate: any) => {
    const currentDate = event;
    const uri = `slotdates/check?date=${currentDate}`;
    setDate(currentDate);
    setSelectedTime(null);
    const response = await fetchDataTrace({ uri });
    setAvailability(response?.payload);
  };

  const checkAvailability = async (date: any) => {
    setChecking(true);
    const uri = `slotdates/check?date=${date}`;
    const response = await fetchDataTrace({ uri });
    setAvailability(response?.payload);
    setChecking(false);
  };

  const handleFetchModels = async () => {
    const uri = `quotations/models/all`;
    const response = await fetchDataTrace({ uri });
    setModels(response);
  };

  const yearOptions = years?.map((item: any, index: number) => (
    <Option value={item?.year} key={index}>
      {item?.year}
    </Option>
  ));

  const modelOptions = models?.map((item: any, index: number) => (
    <Option value={item?.name} key={index}>
      {item?.name}
    </Option>
  ));

  const handleModelChange = (e: any) => {
    if (e === "OTHER MODEL") {
      setIsOtherModel(true);
    } else {
      setIsOtherModel(false);
    }
  };

  const changeHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  useEffect(() => {
    handleFetchModels();
  }, [isVisible]);

  return (
    <Modal
      visible={isVisible}
      title={
        <div className="flex items-center">
          <img src={logo} alt="Logo" height={20} width={50} />
          <span className="ml-2">New Booking</span>
        </div>
      }
      onCancel={hideModal}
      width={800}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createBooking"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createBooking"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout={"vertical"}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="customer_name"
              label="Full Name"
              rules={[
                {
                  required: true,
                  message: "Please enter full name",
                },
              ]}
            >
              <Input
                placeholder="Customer Name"
                style={{ backgroundColor: "#dcfce7" }}
              />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="customer_mobile"
              label="Mobile Number"
              rules={[
                {
                  required: true,
                  message: "Please enter mobile number",
                },
              ]}
            >
              <Input
                addonBefore="+255"
                style={{ backgroundColor: "#dcfce7" }}
                placeholder="Customer Mobile"
                status={"warning"}
              />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="customer_address"
              label="Address"
              rules={[
                {
                  required: true,
                  message: "Please enter address",
                },
              ]}
            >
              <Input
                placeholder="Customer Address"
                style={{ backgroundColor: "#dcfce7" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="customer_email"
              label="Email ( Optional )"
              rules={[
                {
                  required: false,
                  message: "Please enter email",
                },
              ]}
            >
              <Input placeholder="Customer Email" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="vehicle"
              label="Vehicle Registration"
              rules={[
                {
                  required: true,
                  message: "Please enter vehicle registration",
                },
              ]}
            >
              <Input
                placeholder="Vehicle Registration"
                style={{ backgroundColor: "#dcfce7" }}
              />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="mileage"
              label="Mileage"
              rules={[
                {
                  required: true,
                  message: "Please enter mileage",
                },
              ]}
            >
              <Input
                placeholder="Mileage"
                type={"number"}
                style={{ backgroundColor: "#dcfce7" }}
              />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="vehicle_vin"
              label="VIN Number (Optional)"
              rules={[
                {
                  required: false,
                  message: "Please enter vin number",
                },
              ]}
            >
              <Input placeholder="e.g AHTYZ52G80-8015984" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="vehicle_engine"
              label="Engine Number (Optional)"
              rules={[
                {
                  required: false,
                  message: "Please enter engine number",
                },
              ]}
            >
              <Input placeholder="e.g 5L-5318582" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="model"
              label="Model Name"
              rules={[
                {
                  required: true,
                  message: "Please select model",
                },
              ]}
            >
              <Select
                placeholder="Model Name"
                onChange={(e) => handleModelChange(e)}
                style={{ backgroundColor: "#dcfce7" }}
                dropdownStyle={{ backgroundColor: "#dcfce7" }}
                status={"warning"}
              >
                {modelOptions}
                <Option
                  value={"OTHER MODEL"}
                  style={{ backgroundColor: "#dcfce7" }}
                >
                  OTHER MODEL
                </Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          {isOtherModel ? (
            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                name="othermodel"
                label="Specify Model"
                rules={[
                  {
                    required: true,
                    message: "Please enter Model name",
                  },
                ]}
              >
                <Input
                  placeholder="Specify Model Name"
                  style={{ backgroundColor: "#dcfce7" }}
                />
              </Form.Item>
            </Col>
          ) : null}
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="year"
              label="Model Year"
              rules={[
                {
                  required: true,
                  message: "Please enter year",
                },
              ]}
            >
              <Select
                placeholder="Model Year"
                style={{ backgroundColor: "#dcfce7" }}
                status={"warning"}
              >
                {yearOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="description"
              label="Service Type"
              rules={[
                {
                  required: true,
                  message: "Please select servicer type",
                },
              ]}
            >
              <Select
                placeholder="Service Type"
                status={"warning"}
                onChange={(e) => {
                  if (e === "EM120") {
                    setEm(true);
                  } else {
                    setEm(false);
                  }
                }}
              >
                <Option value={"Periodic Service"}>Periodic Service</Option>
                <Option value={"Value Plus"}>Value Plus</Option>
                <Option value={"EM120"}>Express Service (EM120)</Option>
                <Option value={"Mechanical Repairs"}>Mechanical Repairs</Option>
                <Option value={"Body Shop Repairs"}>Body Shop Repairs</Option>
                <Option value={"Auto Valet"}>Auto Valet</Option>
                <Option value={"Paint Campaign"}>Paint Campaign</Option>
                <Option value={"Wheel Alignment & Others"}>
                  Wheel Alignment & Others
                </Option>
                {specialServiceSites?.includes(user?.site?.name) && (
                  <Option value="Special Service Package (Engines up to 2500cc)">
                    Special Service Package (Engines up to 2500cc)
                  </Option>
                )}
                {safariServiceSites?.includes(user?.site?.name) && (
                  <Option value=" Pre-Safari Inspection">
                    Pre-Safari Inspection
                  </Option>
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="date"
              label="Date"
              rules={[
                {
                  required: true,
                  message: "Please select date",
                },
              ]}
            >
              <DatePicker
                format={"Do MMM, YYYY"}
                onChange={onChangeDate}
                className="w-full"
                style={{ backgroundColor: "#dcfce7" }}
                disabledDate={disabledDate}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          {date ? (
            <Col xs={{ span: 24 }} lg={{ span: 8 }}>
              <Form.Item
                name="time"
                label="Time"
                rules={[
                  {
                    required: false,
                    message: "Please select time",
                  },
                ]}
              >
                {selectedTime ? (
                  <div
                    className="border p-1 w-full px-2 text-black"
                    onClick={() => setSlotModal(true)}
                  >
                    {moment(selectedTime?.starttime).format("HH:mm")}
                    {" - "}
                    {moment(selectedTime?.endtime).format("HH:mm")}
                  </div>
                ) : (
                  <div
                    onClick={() => setSlotModal(true)}
                    className="border p-1 w-full px-2 text-gray-400 hover:cursor-pointer bg-green-100"
                  >
                    Time
                  </div>
                )}
              </Form.Item>
            </Col>
          ) : null}
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="file"
              label="Registration Card ( Optional )"
              rules={[
                {
                  required: false,
                  message: "Please select file",
                },
              ]}
            >
              <Input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                placeholder="Document"
                onChange={changeHandler}
              />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 8 }}>
            <Form.Item
              name="promo_code"
              label="Promo Code ( Optional )"
              rules={[
                {
                  required: false,
                  message: "Please enter Promo Code",
                },
              ]}
            >
              <Input placeholder="Promo Code" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="customer_comments"
              label="Additional Remarks ( Optional )"
              rules={[
                {
                  required: false,
                  message: "Please enter additional remarks",
                },
              ]}
            >
              <TextArea rows={2} />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Modal
        visible={slotModal}
        title={`Booking Slots :  ${moment(date).format("Do MMM, YYYY")}`}
        onCancel={handleHideModal}
        footer={false}
      >
        {availability?.data[0]?.slottimes?.map((slot: any, index: number) => {
          return (
            <div
              className={`flex justify-between items-center border-t py-2 ${
                slot?.bookings?.length >= count
                  ? "bg-gray-100 cursor-not-allowed"
                  : "cursor-pointer"
              } ${
                isEm
                  ? checkEM120(slot?.bookings) === 0
                    ? "bg-gray-100 cursor-not-allowed"
                    : ""
                  : ""
              }`}
              key={index}
              onClick={() => {
                if (slot?.bookings?.length >= count) {
                } else if (isEm && checkEM120(slot?.bookings) === 0) {
                } else {
                  setSelectedTime(slot);
                  setSlotModal(false);
                }
              }}
            >
              <div className="flex">
                <div className="mr-2">{index + 1}.</div>
                <div className="flex ml-4">
                  <span style={{ color: "#323232" }}>
                    {moment(slot?.starttime).format("HH:mm")}
                  </span>
                  <span className="mx-4">-</span>
                  <span style={{ color: "#323232" }}>
                    {moment(slot?.endtime).format("HH:mm")}
                  </span>
                </div>
              </div>
              <div className="flex justify-center items-center ml-4">
                <div className="bg-gray-200 text-center py-1 mr-4 w-64">
                  <div className="">
                    {slot?.bookings?.length >= 10 ? (
                      <div className="text-gray-400">
                        <span>Fully Booked</span>
                      </div>
                    ) : (
                      <div className="text-red-600">
                        <span>{count - slot?.bookings?.length}</span>
                        <span className="mx-2">Total Slots Left </span>[ EM120
                        {" : "}
                        {checkEM120(slot?.bookings)} Left ]
                      </div>
                    )}
                  </div>
                </div>
                <div className="h-8 w-8 border flex justify-center items-center">
                  {selectedTime?._id === slot?._id ? (
                    <MdCheck size={20} color="green" />
                  ) : null}
                </div>
              </div>
            </div>
          );
        })}
        {availability?.data[0]?.slottimes?.length === 0 ||
          (availability === null && (
            <div className="flex justify-center items-center">
              <button
                onClick={() => checkAvailability(date)}
                className="bg-toyota text-white py-1 px-4"
              >
                {isChecking ? "Fetching...." : "Fetch Slots"}
              </button>
            </div>
          ))}
      </Modal>
    </Modal>
  );
}
